<template>
  <div class="payAppliable">
    <div class="mainContentWrap">
      <div class="top2">
        <el-row>
          <el-col :span="6">
            <div class="echartWrap" v-if="projectPayList.length>0">
              <div class="title">{{projectPayList[0]['deptName']}}</div>
              <div class="sum">工程施工成本：{{formatCurrency(projectPayList[0]['cost'])}}</div>
              <div class="echart1" id="echart311"></div>
            </div>
            <div class="echartWrap" v-else>
              <div class="title"></div>
              <div class="noechart">暂无数据</div>
            </div>
            <div class="echartWrap" v-if="projectPayList.length>1">
              <div class="title">{{projectPayList[1]['deptName']}}</div>
              <div class="sum">工程施工成本：{{formatCurrency(projectPayList[1]['cost'])}}</div>
              <div class="echart1" id="echart312"></div>
            </div>
            <div class="echartWrap" v-else>
              <div class="title"></div>
              <div class="noechart">暂无数据</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="echartWrapCenter">
              <div class="top2_top">
                <div class="top2_title">
                  付款申请
                  <!--                                    <div class="unitClass">单位：元</div>-->
                </div>
                <div class="headerData">
                  <div class="headerAll">工程施工总成本 : {{formatCurrency(sumData.cost)}}</div>
                  <div class="unitClass">单位：元</div>
                </div>
                <el-row>
                  <!--                                    <el-col :span="9">-->
                  <!--                                        <div class="top_sum">-->
                  <!--                                            工程施工总成本-->
                  <!--                                            <br/>-->
                  <!--                                            {{formatCurrency(sumData.cost)}}-->
                  <!--                                        </div>-->
                  <!--                                        <div class="top_sum top_sum1">-->
                  <!--                                            <div>-->
                  <!--                                                已付款-->
                  <!--                                                <br/>-->
                  <!--                                                {{formatCurrency(sumData.alreadyPay)}}-->
                  <!--                                            </div>-->
                  <!--                                            <div>-->
                  <!--                                                再付款-->
                  <!--                                                <br/>-->
                  <!--                                                {{formatCurrency(sumData.allThisPay)}}-->
                  <!--                                            </div>-->
                  <!--                                            <div>-->
                  <!--                                                欠款-->
                  <!--                                                <br/>-->
                  <!--                                                {{formatCurrency(sumData.debtAmount)}}-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                    </el-col>-->
                  <el-col :span="8">
                    <div class="echart1" id="echart31CenterTop1"></div>
                  </el-col>
                  <el-col :span="8">
                    <div class="echart1" id="echart31CenterTop2"></div>
                  </el-col>
                  <el-col :span="8">
                    <div class="echart1" id="echart31CenterTop3"></div>
                  </el-col>
                </el-row>
              </div>
              <div class="top2_bottom">
                <div class="echart1" id="echart31CenterBottom"></div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="echartWrap" v-if="projectPayList.length>5">
              <div class="title">{{projectPayList[5]['deptName']}}</div>
              <div class="sum">工程施工成本：{{formatCurrency(projectPayList[5]['cost'])}}</div>
              <div class="echart1" id="echart316"></div>
            </div>
            <div class="echartWrap" v-else>
              <div class="title"></div>
              <div class="noechart">暂无数据</div>
            </div>
            <div class="echartWrap" v-if="projectPayList.length>6">
              <div class="title">{{projectPayList[6]['deptName']}}</div>
              <div class="sum">工程施工成本：{{formatCurrency(projectPayList[6]['cost'])}}</div>
              <div class="echart1" id="echart317"></div>
            </div>
            <div class="echartWrap" v-else>
              <div class="title"></div>
              <div class="noechart">暂无数据</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="bottom1">
        <el-col :span="6">
          <div class="echartWrap" v-if="projectPayList.length>2">
            <div class="title">{{projectPayList[2]['deptName']}}</div>
            <div class="sum">工程施工成本：{{formatCurrency(projectPayList[2]['cost'])}}</div>
            <div class="echart1" id="echart313"></div>
          </div>
          <div class="echartWrap" v-else>
            <div class="title"></div>
            <div class="noechart">暂无数据</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="echartWrap" v-if="projectPayList.length>3">
            <div class="title">{{projectPayList[3]['deptName']}}</div>
            <div class="sum">工程施工成本：{{formatCurrency(projectPayList[3]['cost'])}}</div>
            <div class="echart1" id="echart314"></div>
          </div>
          <div class="echartWrap" v-else>
            <div class="title"></div>
            <div class="noechart">暂无数据</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="echartWrap" v-if="projectPayList.length>4">
            <div class="title">{{projectPayList[4]['deptName']}}</div>
            <div class="sum">工程施工成本：{{formatCurrency(projectPayList[4]['cost'])}}</div>
            <div class="echart1" id="echart315"></div>
          </div>
          <div class="echartWrap" v-else>
            <div class="title"></div>
            <div class="noechart">暂无数据</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="echartWrap" v-if="projectPayList.length>7">
            <div class="title">{{projectPayList[7]['deptName']}}</div>
            <div class="sum">工程施工成本：{{formatCurrency(projectPayList[7]['cost'])}}</div>
            <div class="echart1" id="echart318"></div>
          </div>
          <div class="echartWrap" v-else>
            <div class="title"></div>
            <div class="noechart">暂无数据</div>
          </div>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
import { getPayAnalysis } from "../../services/dataCenterAService";

var echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pie");
require("echarts/lib/chart/line");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  name: "payAppliable",
  data() {
    return {
      projectPayList: [],
      searchForm: {
        deptName: "",
        projectName: "",
        enterDate: ""
      },
      deptNameList: [],
      projectNameList: [],
      //   中间部分数据
      sumData: {},
      echartsSumData: [],
      echartsSumDataName: [],
      allEchart31: {},
      allEchart31Center: {},
      echart31CenterBottom: null
    };
  },
  methods: {
    setWrapHeight() {
      //外面div大小
      let ch = document.documentElement.clientHeight;
      let cw = document.documentElement.clientWidth - 40;
      // 里面的div大小
      let chw = document.documentElement.clientHeight - 100;
      let cww = document.documentElement.clientWidth - 60;
      if (document.getElementById("aside")) {
        ch = ch - 50 - 30;
        cw = cw - 280;
        chw = chw - 50 - 30;
        cww = cww - 280;
      }
      if (chw < 700) {
        chw = 700;
      }
      if (cww < 1560) {
        cww = 1560;
      }
      // document.getElementsByClassName("payAppliable")[0].style.width =
      //   cww + "px";
      document.getElementsByClassName("payAppliable")[0].style.height =
        chw + "px";
      this.$nextTick(() => {
        if (this.allEchart31) {
          for (let i in this.allEchart31) {
            if (this.allEchart31[i]) {
              this.allEchart31[i].resize();
            }
          }
        }
        if (this.allEchart31Center) {
          for (let j in this.allEchart31Center) {
            if (this.allEchart31Center[j]) {
              this.allEchart31Center[j].resize();
            }
          }
        }
        if (this.echart31CenterBottom) {
          this.echart31CenterBottom.resize();
        }
      });
    },
    search(searchData) {
      let _this = this;
      let params = {};
      if (searchData.enterDate) {
        params.enterDate = searchData.enterDate;
      }
      if (searchData.projectProcess) {
        params.projectProcess = searchData.projectProcess;
      }

      //查询看板数据
      getPayAnalysis(params)
        .then(res => {
          if (res.code === 10000000) {
            _this.sumData = res.data;
            _this.projectPayList = res.data.projectPayList;
            _this.echartsSumData = [[], [], [], []];
            _this.echartsSumDataName = [];
            _this.projectPayList.forEach((item, index) => {
              _this.echartsSumData[0].push(item.cost);
              _this.echartsSumData[1].push(item.alreadyPay);
              _this.echartsSumData[2].push(item.allThisPay);
              _this.echartsSumData[3].push(item.debtAmount);
              _this.echartsSumDataName.push(item.deptName);
            });
            this.$nextTick(() => {
              this.setData(); //周围饼状图
              //中间饼状图
              this.setcenterData(); //中间饼状图
              this.drawBar(); //中间柱状图
            });
          } else if (res.code > 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$message.error("系统异常");
          }
        })
        .catch(error => {
          this.$message.error("系统异常");
        });
    },
    reset() {
      this.$refs["searchForm"].resetFields();
    },
    setData() {
      let _this = this;
      this.projectPayList.forEach((item, index) => {
        setTimeout(() => {
          _this.draw(item, index + 1);
        }, 20);
      });
    },
    setcenterData() {
      let _this = this;
      let data = [
        {
          color: ["#f79646", "#4bacc6"],
          legendData: ["已付款", "欠款"],
          seriesData: [
            // {value: parseInt(this.sumData.alreadyPayPct1), name: "已付款"},
            // {value: parseInt(this.sumData.debtAmountPct1), name: "欠款"}
            { value: this.sumData.alreadyPay, name: "已付款" },
            { value:this.sumData.debtAmount, name: "欠款" }
          ]
        },
        {
          color: ["#f79646", "#72519a", "#4bacc6"],
          legendData: ["已付款", "拟付款", "欠款"],
          seriesData: [
            // {value: parseInt(this.sumData.alreadyPayPct2), name: "已付款"},
            // {value: parseInt(this.sumData.thisPayPct2), name: "拟付款"},
            // {value: parseInt(this.sumData.debtAmountPct2), name: "欠款"}
            { value: this.sumData.alreadyPay, name: "已付款" },
            { value: this.sumData.thisPay, name: "拟付款" },
            {
              value: this.sumData.debtAmountAfterThisPay,
              name: "欠款"
            }
          ]
        },
        {
          color: ["#b65708", "#4bacc6"],
          legendData: ["再付款", "欠款"],
          seriesData: [
            // {value: parseInt(this.sumData.allThisPayPct3), name: "再付款"},
            // {value: parseInt(this.sumData.debtAmountPct3), name: "欠款"}
            { value: this.sumData.allThisPay, name: "再付款" },
            {
              value: this.sumData.debtAmountAfterThisPay,
              name: "欠款"
            }
          ]
        }
      ];
      data.forEach((item, index) => {
        setTimeout(() => {
          _this.drawCenter(item, index + 1);
        }, 20);
      });
    },
    //绘制中间部分echarts饼状图
    drawCenter(item, index) {
      let _this = this;
      let idName = "echart31CenterTop" + index;
      // let centerChart = echarts.init(document.getElementById(idName));
      this.$set(
        this.allEchart31Center,
        idName,
        echarts.init(document.getElementById(idName))
      );
      let option = {
        title: {
          show: false
        },
        tooltip: {
          trigger: "item",
          showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
          hideDelay: 20, // 隐藏延迟，单位ms
          textStyle: {
            fontSize: "16px",
            color: "#fff" // 设置文本颜色 默认#FFF
          },
          formatter: "{b} : {d}%"
        },
        legend: {
          orient: "horizontal",
          // icon: 'circle',
          bottom: 10,
          itemHeight: 5,
          itemWidth: 5,
          left: "center",

          data: item.legendData,
          textStyle: { color: "#415c7b" }
        },
        color: item.color,
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            center: ["50%", "40%"],
            data: item.seriesData,
            // 设置值域的那指向线
            labelLine: {
              normal: {
                show: false // show设置线是否显示，默认为true，可选值：true ¦ false
              }
            },
            // 设置值域的标签
            label: {
              normal: {
                padding: [0, -40],
                textStyle: {
                  fontSize: 8,
                  // color: 'rgba(0,0,0,0.8)',
                  color: "#415c7b"
                },
                // formatter: "{b}\n{d}%"
                formatter: function(params) {
                  let txt = "";
                  // txt = params.name + '\n' + params.percent + '%' + '\n' + _this.formatCurrency(params.value)
                  txt =
                    params.name +
                    " " +
                    params.percent +
                    "%" +
                    "\n" +
                    _this.formatCurrency(params.value);
                  return txt;
                }
              }
            }
          }
        ]
      };
      this.allEchart31Center[idName].setOption(option);
    },
    //    绘制echarts饼状图图
    draw(item, index) {
      let _this = this;
      let idName = "echart31" + index;
      // let myChart = echarts.init(document.getElementById(idName));
      this.$set(
        this.allEchart31,
        idName,
        echarts.init(document.getElementById(idName))
      );
      let option = {
        title: {
          show: false
        },
        tooltip: {
          trigger: "item",
          showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
          hideDelay: 20, // 隐藏延迟，单位ms
          textStyle: {
            fontSize: "16px",
            color: "#fff" // 设置文本颜色 默认#FFF
          },
          // formatter: "{b} : {d}%"
          formatter: function(params) {
            let txt = "";
            txt =
              params.name +
              "\n" +
              params.percent +
              "%" +
              "\n" +
              _this.formatCurrency(params.value);
            return txt;
          }
        },
        legend: {
          orient: "horizontal",
          // icon: 'circle',
          bottom: 5,
          itemHeight: 5,
          itemWidth: 5,
          left: "center",
          data: ["已付款", "拟付款", "欠款"],
          textStyle: { color: "#415c7b" }
        },
        color: ["#f79646", "#72519a", "#4bacc6"],
        series: [
          {
            name: "",
            type: "pie",
            radius: "58%",
            center: ["50%", "47%"],
            data: [
              // {value: parseInt(item.alreadyPayPct), name: "已付款"},
              // {value: parseInt(item.thisPayPct), name: "拟付款"},
              // {value: parseInt(item.debtPct), name: "欠款"}
              { value: item.alreadyPay, name: "已付款" },
              { value: item.thisPay, name: "拟付款" },
              { value: item.debtAmount, name: "欠款" }
            ],

            // 设置值域的那指向线
            labelLine: {
              normal: {
                show: false // show设置线是否显示，默认为true，可选值：true ¦ false
              }
            },
            // 设置值域的标签
            label: {
              normal: {
                padding: [0, -30],
                textStyle: {
                  fontSize: 8,
                  // color: 'rgba(0,0,0,0.8)',
                  color: "#415c7b"
                },
                // formatter: "{b}\n{d}%"
                formatter: function(params) {
                  let txt = "";
                  // txt = params.name + '\n' + params.percent + '%' + '\n' + _this.formatCurrency(params.value)
                  txt =
                    params.name +
                    " " +
                    params.percent +
                    "%" +
                    "\n" +
                    _this.formatCurrency(params.value);
                  return txt;
                }
              }
            }
          }
        ]
      };
      // myChart.setOption(option);
      this.allEchart31[idName].setOption(option);
    },
    //绘制中间部分柱状图
    drawBar() {
      // let barChart = echarts.init(
      //   document.getElementById("echart31CenterBottom")
      // );
      this.echart31CenterBottom = echarts.init(
        document.getElementById("echart31CenterBottom")
      );

      let option = {
        legend: {
          orient: "horizontal",
          bottom: 6,
          itemHeight: 8,
          itemWidth: 8,
          left: "center"
        },
        grid: {
          left: "5%",
          right: "4%",
          bottom: "14%",
          top: "10%",
          containLabel: true
        },
        tooltip: {},
        color: ["#f4b183", "#f79646", "#b65708", "#4bacc6"],
        xAxis: {
          // data: ["第一项目部", "第二项目部", "第三项目部", "第四项目部", "第五项目部", "第六项目部", '第七项目部', '其它项目'],
          data: this.echartsSumDataName,
          axisLabel: {
            interval: 0,
            rotate: 40
          },
          axisLine: {
            // 坐标轴 轴线
            show: false // 是否显示
          },
          axisTick: {
            // 坐标轴的刻度
            show: false // 是否显示
          }
        },
        yAxis: {
          show: true, // 是否显示
          type: "value", // 轴类型，默认为 ‘category’
          axisLine: {
            // 坐标轴 轴线
            show: false // 是否显示
          },
          axisTick: {
            // 坐标轴的刻度
            show: false // 是否显示
          },
          min: 0
        },
        series: [
          {
            name: "工程施工成本",
            type: "bar",
            barWidth: 8, // 柱形的宽度
            data: this.echartsSumData[0]
          },
          {
            name: "已付款",
            type: "bar",
            barWidth: 8, // 柱形的宽度
            data: this.echartsSumData[1]
          },
          {
            name: "再付款",
            type: "bar",
            barWidth: 8, // 柱形的宽度
            data: this.echartsSumData[2]
          },
          {
            name: "欠款",
            type: "bar",
            barWidth: 8, // 柱形的宽度
            data: this.echartsSumData[3]
          }
        ]
      };
      this.echart31CenterBottom.setOption(option);
    },
    //数字用逗号隔开
    formatCurrency(num) {
      num = Number(num);
      num = num.toFixed(2);
      if (num === 0) {
        return 0;
      } else if (num) {
        num = num.toString().replace(/\$|\,/g, "");
        if (num === "" || isNaN(num)) {
          return 0;
        }
        var sign = "";
        if (num.indexOf("-") !== -1) {
          sign = "-";
          num = num.substr(1);
        }
        var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
        cents = cents.length > 1 ? cents : "";
        num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
        if (cents === "") {
          if (num.length > 1 && num.substr(0, 1) === "0") {
            return 0;
          }
        } else {
          if (num.length > 1 && num.substr(0, 1) === "0") {
            return 0;
          }
        }
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
          num =
            num.substring(0, num.length - (4 * i + 3)) +
            "," +
            num.substring(num.length - (4 * i + 3));
        }
        return sign + num + cents;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.payAppliable {
  /*height: calc(100% - 20px);*/
  /*text-align: left;*/
  /*overflow: hidden;*/
  /*background: #ffffff;*/
  /*padding: 10px;*/
  /*height: calc(100% - 20px);*/
  /*text-align: left;*/
  /*overflow: auto;*/
  /*background: #ffffff;*/
  /*padding: 10px;*/
  /*height: calc(100% - 20px);*/
  /*height: 705px;*/
  /*text-align: left;*/
  /*!*overflow: hidden;*!*/
  /*background: #ffffff;*/
  /*padding: 10px;*/

  text-align: left;
  overflow: hidden;
  background: #ffffff;
  padding: 0 10px;
  /*height: 1660px;*/
  margin: 0 auto;

  .mainContentWrap {
    /*width: 100%;*/
    /*overflow: hidden;*/
    /*height: calc(100% - 100px);*/
    width: 100%;
    /*overflow: hidden;*/
    /*height: calc(100% - 100px);*/
    height: 100%;

    .el-row {
      height: 100%;
    }

    .el-col {
      height: 100%;
    }

    .top2 {
      height: 66%;

      .echartWrapCenter {
        width: calc(100% - 10px);
        height: calc(100% - 10px);
        border: 1px solid #c8c8c8;
        margin: 5px;

        .el-row {
          height: calc(100% - 50px);

          .echart1 {
            height: 100%;
          }
         
        }

        .top2_top {
          height: 50%;

          .top2_title {
            text-align: center;
            font-size: 20px;
            line-height: 50px;
            font-weight: 600;

            /*.unitClass {*/
            /*    float: right;*/
            /*    font-size: 14px;*/
            /*    margin-right: 40px;*/
            /*}*/
          }

          .headerData {
            > div {
              display: inline-block;
            }

            .headerAll {
              font-size: 14px;
              margin-left: 20px;
            }

            .unitClass {
              float: right;
              font-size: 14px;
              margin-right: 20px;
            }
          }

          .top_sum {
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            height: 60px;
            line-height: 30px;
            background: #bdd0e9;
            padding: 5px 0;
            width: 90%;
            margin: 0px auto 6px;
          }

          .top_sum1 {
            font-size: 12px;
            background: #ffffff;
            color: rgba(0, 0, 0, 0.7);
            margin: 0 auto;
            display: flex;
            line-height: 20px;
            justify-content: space-between;
          }

          .top_sum1 > div {
            width: 30%;
            padding-top: 10px;
          }

          .top_sum1 > div:nth-of-type(1) {
            background: #f4b183;
          }

          .top_sum1 > div:nth-of-type(2) {
            background: #00b050;
          }

          .top_sum1 > div:nth-of-type(3) {
            background: #ffc000;
          }
        }

        .top2_bottom {
          height: 50%;
          width: 90%;
          margin: 0 auto;

          .echart1 {
            height: 100%;
          }
        }
      }

      .echartWrap {
        height: calc(50% - 10px);
      }
    }

    .bottom1 {
      height: 33%;

      .echartWrap {
        height: calc(100% - 10px);
      }
    }

    .echartWrap {
      width: calc(100% - 10px);
      height: calc(100% - 10px);
      border: 1px solid #c8c8c8;
      margin: 5px;

      .title {
        text-align: center;
        font-size: 16px;
        margin: 5px 0;
        font-weight: 600;
      }

      .sum {
        font-size: 14px;
        margin: 0 0 5px 40px;
        font-weight: 600;
      }

      .echart1 {
        height: calc(100% - 40px);
      }
       .noechart {
            height:calc(100% - 100px);
            text-align: center;
            font-size: 20px;
            line-height: 50px;
            font-weight: 600;
            padding-top: 80px;
          }
    }
  }
}
</style>

